import appGlobalScript from '/home/vsts/work/1/s/packages/apps/savings-plan/src/global/app.ts';
export const globalScripts = appGlobalScript;
